import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * How much of the match a list screen is showing, and how to see the rest — GEN-61.
 *
 * Extracted when `Lessons` became the second caller. It says the range rather than the
 * page number because the total is the point: a list that shows 25 of 340 and says
 * "page 1" has not told the reader the thing they need to decide whether to filter.
 */
export const PAGE = 25;

export function Pager({
  offset,
  total,
  onOffset,
  pageSize = PAGE,
}: {
  offset: number;
  total: number;
  onOffset: (offset: number) => void;
  pageSize?: number;
}) {
  if (total <= pageSize) return null;

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <Button
        size="small"
        disabled={offset === 0}
        onClick={() => {
          onOffset(Math.max(0, offset - pageSize));
        }}
      >
        Previous
      </Button>
      <Typography variant="body2">
        {String(offset + 1)}–{String(Math.min(offset + pageSize, total))} of{' '}
        {String(total)}
      </Typography>
      <Button
        size="small"
        disabled={offset + pageSize >= total}
        onClick={() => {
          onOffset(offset + pageSize);
        }}
      >
        Next
      </Button>
    </Stack>
  );
}
